import {
  Surcharge,
} from '@dapi/sdk';
import {
  currency,
} from './currency';

export const surcharge: Surcharge = {
  value: 2299,
  currencyCode: 'AED',
  currency,
  code: 'Q'
};
